<template>
  <div class="bg-white">
    <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
      <div class="space-y-12">
        <div class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
          <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl text-red-600">Co umíme</h2>
          <p class="text-xl text-gray-500">Specializujeme se na fixní protetiku. Práce na implantátech jsou pro nás rutina. Hravě si poradíme i se složitějšími řešeními jako jsou Brånemark či hybridní můstky. Podívejte se do galerie na některé naše práce.</p>
        </div>
      <!-- SMALL GALLERY -->
      <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
          <li v-for="(person, index) in people" :key="person.name" class="relative">
            <!-- <span>{{ index }}</span> -->
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="person.imageUrl[0]" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button @click="showMultiple(index)" type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">Zobrazit detail {{ person.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ person.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ person.role }}</p>
          </li>
        </ul>
        <!-- SMALL GALLERY END -->

        <!-- SMALL GALLERY -->
      <!-- <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
          <li v-for="item in gallery2" :key="item.name" class="relative">
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="item.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for {{ item.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ item.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ item.role }}</p>
          </li>
        </ul> -->
        <!-- SMALL GALLERY END -->


        <!-- RANDOM GALLERY -->
      <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
        <li v-for="(image, index) in randomImages" :key="image.name" class="relative">
          <!-- <span>{{ index }}</span> -->
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="image.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button @click="showRandom(index)" type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">Zobrazit detail {{ image.name }}</span>
              </button>
            </div>
            <!-- <span>{{ image[index] }}</span> -->
            <!-- <span>{{ randomImagesUrl }}</span> -->
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ image.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ image.role }}</p>
        </li>
          <!-- <li class="relative">
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img @click="showSingle" :src="image1.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for {{ image1.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ image1.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ image1.role }}</p>
          </li>
                    <li class="relative">
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="image2.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for {{ image2.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ image2.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ image2.role }}</p>
          </li>
                    <li class="relative">
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="image3.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for {{ image3.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ image3.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ image3.role }}</p>
          </li>
                    <li class="relative">
            <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-red-500 overflow-hidden">
              <img :src="image4.imageUrl" alt="" class="object-cover pointer-events-none group-hover:opacity-75" />
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for {{ image4.name }}</span>
              </button>
            </div>
            <p class="mt-2 block text-sm font-medium text-red-600 truncate pointer-events-none">{{ image4.name }}</p>
            <p class="block text-sm font-medium text-gray-500 pointer-events-none">{{ image4.role }}</p>
          </li> -->
        </ul>
        <!-- RANDOM GALLERY END -->

        <!-- LARGE GALLERY -->
        <!-- <ul class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
          <li v-for="person in people" :key="person.name">
            <div class="space-y-4">
              <div class="aspect-w-3 aspect-h-2">
                <img class="object-cover shadow-lg rounded-lg pointer-events-none group-hover:opacity-75" :src="person.imageUrl" alt="" />
              </div>

              <div class="space-y-2">
                <div class="text-lg leading-6 font-medium space-y-1">
                  <h3>{{ person.name }}</h3>
                  <p class="text-red-600">{{ person.role }}</p>
                </div>
              </div>
            </div>
          </li>
        </ul> -->
        <!-- LARGE GALLERY END -->

        <!-- VUE LIGHTBOX TEST -->

        <div>
          <!-- all props & events -->
          <vue-easy-lightbox
            scrollDisabled
            :visible="visible"
            :imgs="imgs"
            :index="index"
            @hide="handleHide"
          ></vue-easy-lightbox>
        </div>

        <!-- VUE LIGHTBOX TEST END -->
      </div>
    </div>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

const people = [
  {
    name: 'zirkon vrstvený',
    role: 'Zirkon vrstvený',
    imageUrl: [
      require('@/assets/img/gallery/8/1.jpg'),
      require('@/assets/img/gallery/8/2.jpg'),
      require('@/assets/img/gallery/8/3.jpg'),
      require('@/assets/img/gallery/8/4.jpg'),
      require('@/assets/img/gallery/8/5.jpg'),
      require('@/assets/img/gallery/8/6.jpg'),
      require('@/assets/img/gallery/8/7.jpg'),
      require('@/assets/img/gallery/8/8.jpg'),
    ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Vestibulárně fazetovaný zirkon 11',
    role: 'Zirkon vestibulárně fazetovaný, zub 11',
    imageUrl: [
      require('@/assets/img/gallery/3/1.jpg'),
      require('@/assets/img/gallery/3/2.jpg'),
      require('@/assets/img/gallery/3/3.jpg'),
    ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'e.max',
    role: 'sólo korunky ve frontálním úseku',
    imageUrl: [
      require('@/assets/img/gallery/bevedent/01_front.jpg'),
      require('@/assets/img/gallery/bevedent/02.jpg'),
      require('@/assets/img/gallery/bevedent/03.jpg'),
      require('@/assets/img/gallery/bevedent/04.jpg'),
      require('@/assets/img/gallery/bevedent/05.jpg'),
      require('@/assets/img/gallery/bevedent/06.jpg'),
      require('@/assets/img/gallery/bevedent/07.jpg'),
      ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'zirkon vrstvený',
    role: 'zub 21 na zirkonovém abutmentu',
    imageUrl: [
      require('@/assets/img/gallery/zima/01_front.jpeg'),
      require('@/assets/img/gallery/zima/02.jpg'),
      require('@/assets/img/gallery/zima/03.jpg'),
      require('@/assets/img/gallery/zima/04.jpg'),
      require('@/assets/img/gallery/zima/05.jpg'),
      require('@/assets/img/gallery/zima/06.jpg'),
    ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Fazety + korunky Zirkon BL1',
    role: 'Zirkonové fazety + korunky BL1',
    imageUrl: [
      require('@/assets/img/gallery/5/1.jpg'),
      require('@/assets/img/gallery/5/2.jpg'),
      require('@/assets/img/gallery/5/3.jpg'),
      require('@/assets/img/gallery/5/4.jpg'),
      require('@/assets/img/gallery/5/5.jpg'),
      ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'MK',
    role: 'Metalokeramika',
    imageUrl: [
      require('@/assets/img/gallery/6/1.jpg'),
      require('@/assets/img/gallery/6/2.jpg'),
      require('@/assets/img/gallery/6/3.jpg'),
      require('@/assets/img/gallery/6/4.jpg'),
      require('@/assets/img/gallery/6/5.jpg'),
      require('@/assets/img/gallery/6/6.jpg'),
      ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Branemark',
    role: 'Provizorní All-on-4 řešení',
    imageUrl: [
      require('@/assets/img/gallery/7/1.jpg'),
      require('@/assets/img/gallery/7/2.jpg'),
      require('@/assets/img/gallery/7/3.jpg'),
      require('@/assets/img/gallery/7/4.jpg'),
    ],
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Zirkon korunky a můstky',
    role: 'Zirkonové korunky a můstky anatomické',
    imageUrl: [
      require('@/assets/img/gallery/2/1.jpg'),
      require('@/assets/img/gallery/2/2.jpg'),
      require('@/assets/img/gallery/2/3.jpg'),
    ],
    twitterUrl: '#',
    linkedinUrl: '#',
  }
]

const gallery2 = [{
    name: 'Výroba sintrovaných CoCr prací',
    role: 'CoCr pod metalokeramiku',
    imageUrl:
      require('@/assets/img/gallery/random/01.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 's kovovou výstuží',
    imageUrl:
      require('@/assets/img/gallery/random/02.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 's kovovou výstuží',
    imageUrl:
      require('@/assets/img/gallery/random/03.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Anatomický zirkon',
    role: '3D tištěný model + můstky na ROOTT implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/04.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Anatomický zirkon',
    role: 'Můstky pro fixaci',
    imageUrl:
      require('@/assets/img/gallery/random/05.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Anatomický zirkon',
    role: 'Popis práce',
    imageUrl:
      require('@/assets/img/gallery/random/06.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Anatomický zirkon',
    role: 'Popis práce',
    imageUrl:
      require('@/assets/img/gallery/random/07.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 'nesený na LASAK implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/08.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 'nesený na LASAK implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/09.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 'nesený na LASAK implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/10.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 'nesený na LASAK implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/11.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: 'kompletní HČ, sólo korunky',
    imageUrl:
      require('@/assets/img/gallery/random/12.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Metalokeramika',
    role: 'MK můstky',
    imageUrl:
      require('@/assets/img/gallery/random/13.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Zirkon vrstvený',
    role: 'zub 11',
    imageUrl:
      require('@/assets/img/gallery/random/14.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Brånemark',
    role: '',
    imageUrl:
      require('@/assets/img/gallery/random/15.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Zirkon vrstvený',
    role: '',
    imageUrl:
      require('@/assets/img/gallery/random/16.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Zirkon anatomický',
    role: 'sólo zirkonové korunky na 3D tištěném modelu',
    imageUrl:
      require('@/assets/img/gallery/random/17.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'All-on-4 provizorium',
    role: 'Provizorní branemarkův můstek na 4 implantátech',
    imageUrl:
      require('@/assets/img/gallery/random/18.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },{
    name: 'Zirkon vrstvený',
    role: 'Zirkon vrstvený',
    imageUrl:
      require('@/assets/img/gallery/random/19.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
},{
  name: 'MK',
  role: 'Metalokeramika',
  imageUrl:
    require('@/assets/img/gallery/random/20.jpg'),
  twitterUrl: '#',
  linkedinUrl: '#',
}]

/* Generate four unique random images from gallery2 */
function pickRandomItems(list, count) {
  const shuffled = [...list].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

const randomImages = pickRandomItems(gallery2, 4)

const randomImagesUrl = randomImages.map(item => item.imageUrl)

export default {
  components: {
    VueEasyLightbox,
  },
  setup() {
    return {
      gallery2,
      people,
      randomImages,
      randomImagesUrl,
    }
  },
  data() {
    return {
      imgs: '', // Img Url , string or Array of string
      visible: false,
      index: 0 // default: 0
    }
  },
  methods: {
    showSingle(index) {
      // this.imgs = 'http://via.placeholder.com/350x150'
      // or
      // this.imgs = {
      //   title: 'this is a placeholder',
      //   src: 'http://via.placeholder.com/350x150'
      // }
      this.imgs = randomImages[index].imageUrl
      this.show()
    },
    showRandom(index) {
      // this.imgs = [
      //   require('@/assets/img/gallery/nagreba/01_front.jpg'),
      //   require('@/assets/img/gallery/nagreba/02.jpg')
      // ]
      // or
      this.imgs = randomImagesUrl
      // this.imgs = [
      //   { title: 'test img', src: require('@/assets/img/gallery/nagreba/01_front.jpg') },
      //   require('@/assets/img/gallery/nagreba/02.jpg')
      // ]
      // allow mixing

      this.index = index // index of imgList
      this.show()
    },
    showMultiple(index) {
      // this.imgs = [
      //   require('@/assets/img/gallery/nagreba/01_front.jpg'),
      //   require('@/assets/img/gallery/nagreba/02.jpg')
      // ]
      // or
      this.imgs = people[index].imageUrl
      // this.imgs = [
      //   { title: 'test img', src: require('@/assets/img/gallery/nagreba/01_front.jpg') },
      //   require('@/assets/img/gallery/nagreba/02.jpg')
      // ]
      // allow mixing

      this.index = 0 // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    }
  }
}
</script>
